export default __webpack_public_path__ + "static/media/rectangle2.12ebb581.svg";